export const accountMovement = {
  accountMovementTransaction: "Transaction",
  accountMovementAmount: "Amount",
  accountMovementDeposit: "Deposits",
  accountMovementTransfer: "Transfers",
  accountMovementBet: "Bets",
  accountMovementWithdrawal: "Withdrawals",
  accountMovementBonus: "Bonuses",
  movementsBtnBack: "Back",
  accountMovementBetAll: "All",
  accountMovementBetWon: "Won",
  accountMovementBetLost: "Lost",
  movementsDepositDesc: "History of deposits made to your account",
  movementsTransferDesc: "Transfers sent and received between users",
  movementsBetDesc: "Summary of bets placed and results",
  movementsWithdrawalDesc: "History of processed withdrawals",
  movementsBonusDesc: "Bonuses and promotions received",
  movementsTransferReceived: "Received",
  movementsTransferSent: "Sent",
  movementsTotalBets: "Total Bets",
  movementsTotalWins: "Total Wins",
  movementsNetResult: "Net Result",
  movementsLoadMore: "Load more",
  movementsEmptyTitle: "No transactions",
  movementsEmptyDesc: "You don't have any transactions in this category yet",
  paginationItemsPerPage: "/ page",
  paginationJumpTo: "Go to",
  paginationJumpToConfirm: "confirm",
  paginationPage: "Page",
  paginationPrevPage: "Previous page",
  paginationNextPage: "Next page",
  paginationPrev5: "Previous 5 pages",
  paginationNext5: "Next 5 pages",
  paginationPrevPageTooltip: "Previous page",
  paginationNextPageTooltip: "Next page",
  paginationOf: "of",
  paginationItems: "items",
};
